module.exports = __webpack_public_path__ + "img/tcndxq_img3-6.f7bc949b.png";